import calculateMinutesDuration from 'clientState/calculateMinutesDuration';
import { PerformedSearchRequestContext } from 'clientState/providers/SearchRequestProvider';
import { SegmentFragment } from 'generated/graphql';

type Duration = { min: number; max: number };
type ConnectionDurationCollectorReturnType = {
  add: (arg: SegmentFragment) => void;
  build: () => Duration;
};
const joinRoundTripConnectionDurations = (
  outbound: Duration,
  inbound: Duration
) => {
  const min = Math.max(
    ...[outbound.min, inbound.min].filter((min) => Number.isFinite(min))
  );
  return {
    ...outbound,
    min,
    max: Math.max(outbound.max, inbound.max),
  };
};

export const ConnectionDurationCollector =
  (): ConnectionDurationCollectorReturnType => {
    let min = Infinity;
    let max = 0;

    return {
      add({ sections }) {
        for (let index = 0; index < sections.length - 1; index++) {
          const duration = calculateMinutesDuration(
            sections[index + 1].departureDate,
            sections[index].arrivalDate
          );

          min = Math.min(min, duration);
          max = Math.max(max, duration);
        }
      },
      build() {
        return {
          min,
          max,
        };
      },
    };
  };

const ConnectionDurationByLegCollector = (
  { tripType }: PerformedSearchRequestContext,
  isUnbundle = false
) => {
  const byLeg: ConnectionDurationCollectorReturnType[] = [];

  return {
    add(legId: number, segment: SegmentFragment) {
      byLeg[legId] = byLeg[legId] || ConnectionDurationCollector();
      byLeg[legId].add(segment);
    },
    build() {
      const connectionDurations = byLeg.map((collector) => collector.build());
      if (tripType === 'ROUND_TRIP' && !isUnbundle) {
        return [
          joinRoundTripConnectionDurations(
            connectionDurations[0],
            connectionDurations[1]
          ),
        ];
      }
      return connectionDurations;
    },
  };
};

export default ConnectionDurationByLegCollector;
